import { SwiperSlide } from "swiper/react";
import AppSwiper from "../../common/AppSwiper";
import CategoryCard from "./CategoryCard";
import "./Categories.css";
import HomeContainer from "../HomeContainer/HomeContainer";
export default function Categories({

    categories = []

}) {

    if (!categories.length) {

        return null;

    }

    return (

        <HomeContainer>

         <section className="home-categories">
    <div className="home-categories__slider">
      <AppSwiper
    className="categories-swiper"
    navigation={false}
    spaceBetween={20}
    breakpoints={{
        0: { slidesPerView: 2.2 },
        576: { slidesPerView: 3.2 },
        768: { slidesPerView: 4.2 },
        992: { slidesPerView: 5.2 },
        1200: { slidesPerView: 6 },
    }}
>
            {categories.map((category, index) => (
                <SwiperSlide key={category.id}>
                    <CategoryCard
                        category={category}
                        index={index}
                    />
                </SwiperSlide>
            ))}
        </AppSwiper>
    </div>
</section>
        </HomeContainer>


    );

}